import { ArrowDown, ArrowRightLeft, ArrowUp, GenericSelect, Label } from '@chain-zen/ui'

import type { TStopType } from '../../../../../../types/post'

interface StopTypeInputProps {
  onSubmit: (type: TStopType) => void
  type: TStopType | null
}

/**
 * Input component for editing stop type inline
 */
export const StopTypeInput = ({ type, onSubmit }: StopTypeInputProps) => {
  const handleSelect = (value: TStopType) => {
    if (value !== type) {
      onSubmit(value)
    }
  }

  return (
    <div className="space-y-1">
      <Label className="text-xs font-medium">Stop Type</Label>
      <GenericSelect
        placeholder="Select type"
        value={type || ''}
        onValueChange={(value) => handleSelect(value as TStopType)}
        triggerClassName="h-7! text-xs"
        options={[
          { icon: ArrowUp, label: 'Pick', value: 'Pick' },
          { icon: ArrowDown, label: 'Drop', value: 'Drop' },
          { icon: ArrowRightLeft, label: 'Both', value: 'Both' }
        ]}
      />
    </div>
  )
}
